import type { ThemeColors } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export function primaryLinkClass(colors?: ThemeColors, extra?: string) {
  return colors
    ? cn(colors.primaryFg, 'hover:underline', extra)
    : cn('text-indigo-600 hover:text-indigo-800 hover:underline dark:text-indigo-400', extra);
}

export function mutedTextClass(colors?: ThemeColors, extra?: string) {
  return colors
    ? cn(colors.textMuted, extra)
    : cn('text-gray-500 dark:text-gray-400', extra);
}

export function secondaryTextClass(colors?: ThemeColors, extra?: string) {
  return colors
    ? cn(colors.textSecondary, extra)
    : cn('text-gray-600 dark:text-gray-300', extra);
}

export function secondaryLinkClass(colors?: ThemeColors, extra?: string) {
  return colors
    ? cn(colors.textSecondary, colors.interactiveHover, extra)
    : cn('text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200', extra);
}

export function viewActionClass(colors?: ThemeColors) {
  return colors
    ? cn(colors.primaryFg, colors.interactiveHover, 'p-2 rounded-lg transition-colors')
    : cn(
        'p-2 rounded-lg transition-colors',
        'text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50',
        'dark:text-indigo-400 dark:hover:bg-indigo-900/30',
      );
}

export function editActionClass(colors?: ThemeColors) {
  return colors
    ? cn(colors.primaryFg, colors.interactiveHover, 'p-2 rounded-lg transition-colors')
    : cn(
        'p-2 rounded-lg transition-colors',
        'text-blue-600 hover:text-blue-900 hover:bg-blue-50',
        'dark:text-blue-400 dark:hover:bg-blue-900/30',
      );
}

export function deleteActionClass(colors?: ThemeColors) {
  return colors
    ? cn('p-2 rounded-lg transition-colors text-red-400', colors.interactiveHover)
    : cn(
        'p-2 rounded-lg transition-colors',
        'text-red-600 hover:text-red-900 hover:bg-red-50',
        'dark:text-red-400 dark:hover:bg-red-900/30',
      );
}

export function summaryActionClass(colors?: ThemeColors) {
  return colors
    ? cn('p-2 rounded-lg transition-colors text-amber-400', colors.interactiveHover)
    : cn(
        'p-2 rounded-lg transition-colors',
        'text-amber-600 hover:text-amber-900 hover:bg-amber-50',
        'dark:text-amber-400 dark:hover:bg-amber-900/30',
      );
}

export function cardSurfaceClass(colors?: ThemeColors) {
  return colors
    ? cn(colors.surface, colors.border, 'rounded-lg shadow p-4 border')
    : cn('rounded-lg shadow p-4 border', 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700');
}

export function cardRowClass(colors?: ThemeColors) {
  return colors
    ? cn(colors.border, colors.interactiveHover, 'border rounded p-3 transition-colors')
    : cn(
        'border rounded p-3 transition-colors',
        'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50',
      );
}
